import React from "react";
import BarrarInferior from "./barrarInferior";
import BarraLateral from "./barraLateral";
import VideoPanel from "./video";
export default function Panel(props) {
  return (
    <div
      className="col-md-12 p-0 m-0 row d-flex justify-content-beetween"
      style={{
        height: "94vh",
        background: "#001133",
      }}
    >
      <div className="col-9 p-0 m-0">
        <VideoPanel />
      </div>
      <div className="col-3 p-0 m-0">
        <BarraLateral />
      </div>
      <BarrarInferior />
    </div>
  );
}
